<template>
  <a-modal
    title="添加配方"
    :visible="visible.formula"
    @ok="ok"
    width="900px"
    @cancel="cancel"
    :destroyOnClose="true"
    :forceRender="true"
    :bodyStyle="modalBodyStyle"
  >
    <a-spin :spinning="addLoading">
      <a-row
        style="padding: 0 0 15px"
        type="flex"
        align="middle"
        justify="space-between"
      >
        <a-col>
          <a-input
            v-model="formulaKeyword"
            placeholder="配方名称/配方代码"
            @change="keyChange"
            @search="getList"
          />
        </a-col>
        <div>
          <a-select
            allowClear
            v-model="typeClassify"
            style="width: 200px; margin-right: 20px"
            placeholder="选择配方分类"
            @change="getList"
          >
            <a-select-option :value="0"> 未分类 </a-select-option>
            <a-select-option :value="1"> 自产配方 </a-select-option>
            <a-select-option :value="2"> 代工配方 </a-select-option>
            <a-select-option :value="3"> 定制配方 </a-select-option>
          </a-select>
          <a-select
            v-model="formulaType"
            placeholder="选择配方类型"
            style="width: 200px"
          >
            <a-select-option
              :key="index"
              v-for="(item, index) in ['配合饲料', '混合日粮']"
              :value="index + 1"
            >
              {{ item }}
            </a-select-option>

              <!-- <a-select-option
              :key="index"
              v-for="(item, index) in ['配合饲料']"
              :value="index + 1"
            >
              {{ item }}
            </a-select-option> -->
          </a-select>
        </div>
      </a-row>

      <a-table
        :scroll="{ y: 260 }"
        :columns="columns"
        bordered
        :loading="listLoading"
        :data-source="list.records"
        :row-selection="{
          selectedRowKeys,
          onChange: onTableSelectChange,
          getCheckboxProps,
        }"
        :pagination="false"
        :row-key="(record) => record.id"
      >
        <a-tooltip slot="typeClassify" slot-scope="t">
          <template slot="title">{{ typeClassName(t) }}</template>
          {{ typeClassName(t) }}
        </a-tooltip>
      </a-table>
    </a-spin>
    <template slot="footer">
      <div style="position: relative">
        <p class="pText">
          已选中
          <span class="fontRed">{{ selectedRowKeys.length }}</span> 个配方
        </p>
      </div>
      <a-space>
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" @click="ok" :loading="btnLoading"
          >确定</a-button
        >
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { formulaMixins } from "../unitls";
export default {
  mixins: [formulaMixins],
  emits: ['refresh'],
  watch: {
    "visible.formula"(val) {
      val ? this.getList() : this.restList();
    },
    formulaType(formulaType) {
      this.getList({ formulaType });
    }
  },
  data() {
    return {
      addLoading: false,
      listLoading: false,
      formulaType: 1,
      formulaKeyword: undefined,
      typeClassify: undefined,
      classNames: ['未分类', '自产配方', '代工配方', '定制配方'],
      columns: [
        {
          title: "配方分类",
          dataIndex: "typeClassify",
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: "typeClassify" },
        },
        {
          title: "配方代码",
          dataIndex: "formulaCode"
        },
        {
          title: "配方名称",
          dataIndex: "formulaName"
        },
        {
          title: "动物类型",
          dataIndex: "animalTypeName"
        },
        {
          title: "工厂名称",
          dataIndex: "factoryName"
        },
        {
          title: "用户",
          width: 100,
          dataIndex: "userName"
        }
      ],
      btnLoading: false,
      timer: null
    };
  },
  methods: {
    onTableSelectChange(selectedRowKeys, selectedRows) {
      if (selectedRowKeys.length <= 50) {
        this.onSelectChange(selectedRowKeys, selectedRows);
      } else {
        this.$message.info('最多只能选择50个配方');
        this.onSelectChange(selectedRowKeys.slice(0, 50), selectedRows.slice(0, 50));
      }
    },
    typeClassName(t) {
      return this.classNames[t]
    },
    keyChange() {
      if (this.timer) { clearTimeout(this.timer); }
      this.timer = setTimeout(() => {
        this.getList()
        this.timer = null;
      }, 300)
    },
    getList(arg = {}) {
      const data = {
        factoryId: this.factoryId,
        formulaType: this.formulaType,
        formulaKeyword: this.formulaKeyword,
        typeClassify: this.typeClassify,
        taskId: this.taskId,
        current: 1,
        size: 1000,
        ...arg
      };
      this.fetchGet({
        actions: this.taskFormulaPage,
        isList: true,
        data,
        name: "list",
        loading: "listLoading"
      });
    },
    async addFormula() {
      const data = {
        taskId: this.taskId,
        ids: this.selectedRows.map(i => i.id).join()
      };
      return this.fetchPost({
        actions: this.addTaskFormulaByIds,
        data,
        loading: "addLoading"
      });
    },
    async ok() {
      if (this.selectedRows.length === 0) return
      this.btnLoading = true
      await this.addFormula();
      this.toggleVisible("formula");
      this.$emit("ok");
      this.$emit('refresh')
      this.btnLoading = false
    },
    cancel() {
      this.toggleVisible("formula");
    },
    restList() {
      this.formulaKeyword = undefined
      this.formulaType = 1;
      this.cleanSelect();
    }
  },
  destroyed() {
    this.restList();
  }
};
</script>

<style lang='scss'>
.pText {
  position: absolute;
  top: 0;
  left: 0;
}
.fontRed {
  color: #ff4d4f;
}
</style>
